import request from '@/utils/request'
const apiPath = '/tech/technicianInfo'
import { downloadBlob } from '@/utils/download'
const technicianInfoApi = {
  /**
   * 新增【技术管理】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【技术管理】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 修改【技术管理-级别】
   *
   */
  updateLevel(data) {
    return request.put(apiPath + '/tee/updateLevel', data)
  },
  /**
   * 修改【技术管理-上级】
   *
   */
  updateParent(data) {
    return request.put(apiPath + '/tee/updateParent', data)
  },
  /**
   * 分配督导（教培数据统计的数据范围）
   */
  updateSupervisor(data) {
    return request.put(apiPath + '/tee/updateSupervisor', data)
  },
  /**
   * 分页查询【技术管理】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  listForMini(query) {
    return request.get(apiPath + '/tee/listForMini', { params: query })
  },
  listPageForMini(query) {
    return request.get(apiPath + '/tee/listPageForMini', { params: query })
  },
  resignQuit(data) {
    return request.post(apiPath + '/tee/resign', data)
  },

  /**
   * 查询【技术管理】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【技术管理】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/tee/show/${id}`)
  },
  fetchByIdBig(id) {
    return request.get(`${apiPath}/tee/showBig/${id}`)
  },
  /**
   * 删除单个【技术管理】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 转让
   */
  makeTransfer(data) {
    return request.post(`${apiPath}/tee/transfer`,data)
  },
  transferForBig(data) {
    return request.post(apiPath + '/tee/transferForBig', data)
  },
  /**
   * 在职
   */
  onTheJob(data) {
    return request.post(`${apiPath}/tee/onTheJob`,data)
  },
  // 获取指标配置
  listForQuota(query){
    return request.get(apiPath + '/tee/listForQuota', { params: query })
  },
  // 获取业绩
  getPerformance(id){
    return request.get(`${apiPath}/tee/getPerformance/${id}`)
  },
  getPerformanceBig(id){
    return request.get(`${apiPath}/tee/getPerformanceBig/${id}`)
  },
  /**
   * 获取子集数量
   */
  getChildCount(id){
    return request.get(`${apiPath}/tee/getChildCount/${id}`)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '商品列表.xlsx'))
  },
  //分页查询【技术老师跟进客户记录】
  techFollowCustRecord(query){
    return request.get(`/tech/techFollowCustRecord`, { params: query })
  },
  // 导出
  exportExcels(query) {
    return request.get(apiPath + '/tee/export', { params: query })
  },
  // 数据统计-技术统计-数据统计-技术统计-团队成员
  getListForStatistics(query){
    return request.get(`${apiPath}/tee/listForStatistics`, { params: query })
  },
  getListForStatisticsBig(query){
    return request.get(`${apiPath}/tee/listForStatisticsBig`, { params: query })
  },
  exportQuota(query){
    return request.get(`${apiPath}/tee/exportQuota`, { params: query })
  },
  //
  listForStatisticsDown(query){
    return request.get(`${apiPath}/tee/listForStatisticsDown`, { params: query })
  },
  exportExcelDataStatistics(query){
    return request.get(`${apiPath}/tee/exportExcelDataStatistics`, { params: query })
  },
  exportExcelDataStatisticsBig(query){
    return request.get(`${apiPath}/tee/exportExcelDataStatisticsBig`, { params: query })
  }
}
export default technicianInfoApi
